<template>
  <el-container class="container">
    <el-header height="60px">
      <Header />
    </el-header>
    <el-container>
      <el-aside width="auto">
        <Nav />
      </el-aside>
      <el-container class="common-container">
        <div class="el-main-content flex items-start">
          <el-main ref="el" class="common-main flex flex-col">
            <Suspense>
              <template #default>
                <router-view v-slot="{ Component }">
                  <component class="content" :is="Component" />
                </router-view>
              </template>
              <template #fallback> Loading... </template>
            </Suspense>
          </el-main>
        </div>
      </el-container>
    </el-container>
  </el-container>
</template>

<script setup lang="ts">
import Nav from './components/Nav.vue'
import Header from './components/Header.vue'
import { useCommonStore } from '@/store/useCommonStore'

const store = useCommonStore()

onMounted(() => {
  store.getActiveMarquee()
})
</script>

<style lang="scss">
.container {
  height: 100vh;
}
.el-header {
  color: #fff;
  // background: #262626;
  background: url('@/assets/images/header.png') no-repeat;
  background-size: 100% 100%;
  padding: 0 32px !important;
}
.common-container .common-main {
  height: calc(100vh - 60px);
  padding: 10px;
}
.fullScreen {
  margin: 0 20px;
}
.quickNav {
  border-bottom: 1px solid #666;
}
.el-main-content {
  width: 100%;
  background: rgb(241, 242, 244);
}
.el-aside {
  position: relative;
  z-index: 101;
  background: url('@/assets/images/menu.jpg') no-repeat center center;
  background-size: auto 100%;
  overflow: hidden !important;
}
</style>
